<div class="boxWhite">
  <h4>MI PERFIL</h4>

  <button class="btn btnClose" (click)="close()">
    <img src="assets/img/icoClose.svg" alt="">
  </button>

  <div class="contModal">
    <div class="circle">{{usuario?.given_name.charAt(0)}}{{usuario?.family_name.charAt(0)}}</div>
    <h2>{{usuario?.given_name}} {{usuario?.family_name}}</h2>

    <div class="text-center mt-4">
      <h6 class="clBlack">PERFIL</h6>
      <p class="clGray mb-4">{{groupsTexto}}</p>
    </div>
  </div>

  <div class="footModal">
    <button class="btn btnOrange w-100" (click)="showModalCerrarSesion()">CERRAR SESIÓN</button>
    <small class="versionModal">{{gitV}}</small>
  </div>
</div>

